var emotionUseInsertionEffectWithFallbacks_cjsExports = {};
var emotionUseInsertionEffectWithFallbacks_cjs = {
  get exports(){ return emotionUseInsertionEffectWithFallbacks_cjsExports; },
  set exports(v){ emotionUseInsertionEffectWithFallbacks_cjsExports = v; },
};

export { emotionUseInsertionEffectWithFallbacks_cjs as __module, emotionUseInsertionEffectWithFallbacks_cjsExports as exports };
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.cjs2.js.map
